// extracted by mini-css-extract-plugin
export default {"contenido":"estilo_contenido__BdKZq","datephoto":"estilo_datephoto__Y2yYM","enlace":"estilo_enlace__2F+Sv"};